import { ShieldAlert } from "@cakewalk/ui/icons";
import { V2Button, V2Card, V2CardContent, V2Typography } from "@cakewalk/ui/v2";

/**
 * Shown when a signed-in employee (neither owner nor manager) reaches the census
 * flow. Quoting on the company's behalf is owner/manager-only, so instead of the
 * form we explain that an owner or manager needs to complete it, and offer a way
 * to switch accounts.
 */
export function CompanyCensusOwnerRequiredStep({
  email,
  onUseDifferentAccount,
}: {
  email?: string;
  onUseDifferentAccount: () => void;
}) {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col gap-4 px-4 py-12">
      <V2Card className="overflow-hidden border border-cw-v2-border shadow-cw-v2-card">
        <V2CardContent className="flex flex-col items-center gap-6 p-6 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-cw-v2-reliant-red/10 text-cw-v2-reliant-red">
            <ShieldAlert className="h-6 w-6" aria-hidden />
          </div>

          <div className="flex flex-col gap-2">
            <V2Typography variant="overline" className="text-cw-v2-reliant-red">
              Owners &amp; managers only
            </V2Typography>
            <V2Typography variant="heading-medium" as="h1" className="font-semibold">
              This quote needs an owner or manager
            </V2Typography>
            <V2Typography variant="body" muted>
              {email ? (
                <>
                  You&rsquo;re signed in as <span className="font-medium">{email}</span>, which
                  isn&rsquo;t an owner or manager of this account.{" "}
                </>
              ) : (
                <>This account isn&rsquo;t set up as an owner or manager. </>
              )}
              Only a business owner or manager can start a medical quote for the company. Please ask
              them to log in and complete this step.
            </V2Typography>
          </div>

          <V2Button
            variant="secondary"
            size="lg"
            fullWidth
            onClick={onUseDifferentAccount}
            data-track="button-company-census-owner-required-switch"
          >
            Log in with a different account
          </V2Button>
        </V2CardContent>
      </V2Card>
    </div>
  );
}
